export default __webpack_public_path__ + "static/media/icon-wallet-1.c4397731.svg";